module.exports = __webpack_public_path__ + "img/logo_mfg_en.c2fd4eb9.png";